export const Roles = [
    "Admin",
    "Founder",
    "Investor",
    "Aspiring Entrepreneur",
    "Team Member",
    "Government",
    "NGO",
    "Coaches And Mentors",
    "Curious",
    "Unassigned",
]

export const ProfileStatus =[
  "Not Verified" ,
  "Verified" ,
  "Verified Old User",
  "Verified With Profile",
  "Fully Completed",
]